import { useState, useRef, React} from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
    const Entries = [
        {
            name: "Rhythm Game Beat Manager",
            creationDate: "December 12th 2024",
            description: "The script for displaying beats in Shrimp fried beats",
            link: "https://emgithub.com/iframe.html?target=https%3A%2F%2Fgithub.com%2FXaragameIsHere%2Fshrimp-shooter%2Fblob%2Fmain%2FAssets%2FScripts%2FBeaterator.cs&amp;style=github&amp;type=code&amp;showBorder=on&amp;showLineNumbers=on&amp;showFileMeta=on&amp;showFullPath=on&amp;showCopy=one",
          },
          {
            name: "Use Component",
            creationDate: "July 16th 2023",
            commentary: "Script for have interactible objects and triggers",
            link: "https://emgithub.com/iframe.html?target=https%3A%2F%2Fgithub.com%2FXaragameIsHere%2FBattleOfTheHeart-SourceCode%2Fblob%2Fmain%2FAssets%2FScripts%2FUseComponent.cs&style=github&type=code&showBorder=on&showLineNumbers=on&showFileMeta=on&showFullPath=on&showCopy=on",
              description: "So basically this componenent is for players to be able to click on a key near a certain object and interact with it. It's a pretty simple component, it just checks distance of the player to the button and then when the player presses it the game fires a Unity Event to whatever function in another script is needed.",
          },
          {
            name: "Dialogue System",
            creationDate: "July 6th 2023",
            commentary: "Dialogue System for Battle of the Heart and it's special dialogue interactions",
            link: "https://emgithub.com/iframe.html?target=https%3A%2F%2Fgithub.com%2FXaragameIsHere%2FBattleOfTheHeart-SourceCode%2Fblob%2Fmain%2FAssets%2FScripts%2FplayerUIController.cs&style=github&type=code&showBorder=on&showLineNumbers=on&showFileMeta=on&showFullPath=on&showCopy=on",
            description: "This is the dialogue system for Battle of the Heart. Since this game requires players to interact with and befriend their enemies. Because of this we had to do JSON Parsing to store data regarding every character's dialogue and what all the possibilities are. Then having that JSON Parsed into static classes, then loading that data and letting the player interacting with the dialogue.",
          },
          {
            name: "Grappling Hook",
            creationDate: "February 14th 2024",
            commentary: "2D Grappling Hook",
            link: "https://emgithub.com/iframe.html?target=https%3A%2F%2Fgithub.com%2FXaragameIsHere%2Fgamedevguilduntitledproject%2Fblob%2Fmain%2FAssets%2FScripts%2FgrapplingHook.cs&style=github&type=code&showBorder=on&showLineNumbers=on&showFileMeta=on&showFullPath=on&showCopy=on",
            description: "This code is for a grappling hook mechanic in a 2D zombie game. Essentially it just raycasts in the direction the player points, draws a line renderer and sets the velocity of the player mover to that direction.",
          },
          {
            name: "Enemy Scripting For Battle of the Heart",
            creationDate: "July 4th 2023",
            commentary: "Scripts for handling the behaviors of the enemies of Battle of the Heart",
            link: "https://emgithub.com/iframe.html?target=https%3A%2F%2Fgithub.com%2FXaragameIsHere%2FBattleOfTheHeart-SourceCode%2Fblob%2Fmain%2FAssets%2FScripts%2FenemyScripting.cs&style=github&type=code&showBorder=on&showLineNumbers=on&showFileMeta=on&showFullPath=on&showCopy=on",
            description: "This is the scripting for the enemyies in battle of the heart. If you know anything about the game it revolves around fighting 'enemies' and then talking to them to understand and befriend them. Doing a game like this requires having a bunch of unique enemies with unique attacks. However if you actually look at the game, you'll notice that enemies have different sets of the same attacks. The snipe where the the enemy shoots precise bullets with a particle system, the throwable which is a less precise grenade launch with rigidbodies, the double shot that shoots like a double barrel shot gun with the particle sytem, spray that just sprays bullets like a hose of particles, drop that just drops rigidbody obstacles from the ceiling, narrow that just sprays from a narrow cone of particles. and drop in the big guy just drops in and like moves across the screen and fucks shit up. The idea is to mainly use particle systems to collide with the player and cause damage.",
          },
          {
            name: "3D Movement",
            creationDate: "May 22nd 2024",
            commentary: "3D Movement System for a Mech Robot Game",
            link: "https://emgithub.com/iframe.html?target=https%3A%2F%2Fgithub.com%2FXaragameIsHere%2FeverybodyWantsToRuleTheWorld_Source%2Fblob%2Fmain%2FAssets%2FScripts%2Fscript_movement.cs&style=github&type=code&showBorder=on&showLineNumbers=on&showFileMeta=on&showFullPath=on&showCopy=on",
            description: "This is code I wrote for a game I made back in my 'Design Craft' class from high school I was given the opportunity to work on a game for my final project and I decided working on a 3D arena shooter where you played as a mech pilot fighting against other mechs for coverage on a map. Because of that I needed a 3D player movement for controlling mechs. My main method here was using the character controller component and using the update loop to read input for movement. Input is retrieved from a separate centralized input script that takes input from the new input system. Making it work with a variety of scripts.",
          }
        
    ]
    
    const [selectedEntry, setSelectedEntry] = useState(Entries[0]);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    
    const listItems = Entries.map((Entry, index) =>
                                  <div key={index}>
                                  <MenuListItem style={{ whiteSpace: 'normal', height: 'auto' }} onClick={() => setSelectedEntry(Entry)}>{Entry.name}</MenuListItem>
                                  <Separator />
                                  </div>
                                  );
    
    
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block',width: '80%', height: '75vh' }}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Code Snippets</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/Backpage')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex', flexDirection: "column" }}>
              <div style={{
                  position: 'relative',
                  flex: 4.5,
                  height: '100%',
                }}>
                <iframe
                  src={selectedEntry.link}
                    width="100%"
                    height="100%"
                  scrolling="yes"
                    title="description"              // required for accessibility
                    style={{ border: 'none' }}      // removes default border
                    allowFullScreen                  // enables fullscreen
                    loading="lazy"                   // defers loading until visible
                    sandbox="allow-scripts allow-same-origin"  // security restrictions
                  />
              </div>
            
              
              <div style={{ display: 'flex', flexDirection: 'row', flex: 3, overflow: 'hidden' }}>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <MenuList style={{ display: 'flex', flexDirection: 'column' }}>
                    {listItems}
                  </MenuList>
                </ScrollView>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <div style={{ padding: '1rem' }}>
                    {selectedEntry.description.split('\n\n').map((para, i) => (
                      <p key={i}>{para}</p>
                      ))}
                  </div>
                </ScrollView>
              </div>
                
              
              </Frame>
            
            
            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
